import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as ProductsActions from '../../../actions/productsActions';
import { DebounceInput } from 'react-debounce-input';
import ProductDefaultImage from '../../../assets/images/product-default-image.jpg'
import * as Utils from '../../../utils/utils';
import ReactGA from 'react-ga'
import { withRouter } from 'react-router';
import _ from "lodash";
import SweetAlert from 'sweetalert-react';

class SearchBox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      keyword: '',
      showDropdown: false,
      showCancelButton: false,
      isItemAddedToCart: false,
      showAlert: false,
      swalParams: {
        title: ""
      },
    }
    this.renderResults = this.renderResults.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClose = this._onClose.bind(this);
    this._onKeyUp = this._onKeyUp.bind(this);
    this._searchProducts = _.debounce(this._searchProducts.bind(this), 300);
  }

  _onFocus() {
    this.setState({ showCancelButton: true })
  }
  _onClose() {
    this.setState({ showDropdown: false, keyword: '', showCancelButton: false })
  }

  _onChange(e) {
    let keyword = e.target.value;
    this.setState({ keyword });
  }

  _searchProducts(keyword) {
    if (keyword.length > 1) {
      this.setState({ showCancelButton: true, showDropdown: false });
      this.props.dispatch(ProductsActions.getSearchResultProducts({ keyword: keyword }, response => {
        console.log("PRODUCTS_SEARCH_RESPONSE", response);
        this.setState({ showDropdown: true })
        ReactGA.modalview('/?search=' + keyword);
      }))
  } else {
      this.setState({ showCancelButton: false, showDropdown: false })
    }
  }
  _onKeyUp(e) {
    if (e.key === 'Enter') {
      if(e.target.value.length >= 1) {
        this.props.history.push('/search?q=' + e.target.value);
        this._searchProducts.cancel();
        this.setState({ showDropdown: false });
      }
    } else {
      this._searchProducts(e.target.value)
    }
  }

  addToCart(product) {
    Utils.addToCart(product)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false
          }
        })
        setTimeout(() => this.setState({ showAlert: false }), 1500);
      })
      .catch(err => {
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
        setTimeout(() => this.setState({ showAlert: false }), 2500);
      });
  }

  renderResults() {
    const searchResults = Utils.toJS(this.props.searchResults);

    return (
      <div className="search-results-container">

        <div className="search-results custom-scrollbar">
          {searchResults.length
            ?
            <Link to={`/search?q=${this.state.keyword}`} className="search-results-page-link" onClick={() => this.setState({ showDropdown: false })} >
              <div className="search-results-page-btn">
                View all results
          </div>
            </Link>
            : null}
          {searchResults.length
            ?

            searchResults.map((product) => {

              const isOutOfStock = !(product && product.Qty > 0);
              return (
                <div className="search--item" key={product._id}>
                  <Link to={`/products/${product._id}`} onClick={() => this.setState({ showDropdown: false, keyword: '', showCancelButton: false })}>
                    <div className="media"><img src={product.image ? product.image : ProductDefaultImage} onError={(e) => {
                      return e.target.src = ProductDefaultImage
                    }} /></div>
                    <div className="description">
                      <p><span className="product--name">{this.renderDescription(product)}</span>
                      </p>
                      <p>
                        <span className="product--department">{this.renderDepartment(product.Department, product._id)}</span>
                        <span className="product--category">{this.renderCategory(product.Category, product._id)}</span>
                        <span className="product--size"> {product.Size ? product.Size : ''}</span>
                        <span className="product--price">${product.PriceB}</span>
                      </p>
                    </div>
                  </Link>
                  <div className="add-to-cart-button" onClick={() => this.addToCart(product)}>ADD TO CART</div>
                  {isOutOfStock ? (
                    <div className="outofstock-tag">Out of Stock</div>
                  ) : null}
                </div>
              );
            })
            : (<div className="search--item"><h5>No Product Found</h5></div>)}
        </div>
      </div>
    );
  }
  render() {
    const { showAlert, swalParams } = this.state;
    return (
      <div className="search-box">
        {this.state.showCancelButton
          ? (
            <button onClick={this._onClose}>X</button>
          )
          : null}
        <input onKeyUp={this._onKeyUp} onChange={this._onChange} className="search-input" placeholder="SEARCH BEERS, WINES..." aria-label="SEARCH BEERS, WINES..." value={this.state.keyword} /> {this.state.showDropdown
          ? this.renderResults()
          : null}
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={() => this.setState({ showAlert: false })} show={showAlert} {...swalParams} />
      </div>
    )
  }

  renderDescription(product) {
    const description = product && product.Description ? product['Sub Description 2'] ? product.Description + ' ' + product['Sub Description 2'] : product.Description : '';
    if (!this.state.keyword || this.state.keyword.length < 2) {
      return (<span>{description}</span>)
    }
    const indices = this.getMatchIndices(this.state.keyword, description);
    const splittedStrings = this.getSplittedStrings(description, indices, this.state.keyword);
    if (splittedStrings.length == 0) {
      return (<span>{description}</span>)
    }
    return (
      splittedStrings.map((str, i) => {
        return (
          str.type === 'match' ?
            <span className="match" key={'match_' + product._id + i} >{str.segment}</span>
            : <span key={'match_' + + product._id + i}>{str.segment}</span>
        )
      })
    )
  }

  renderCategory(category, productID) {
    if (!this.state.keyword || this.state.keyword.length < 2) {
      return (<span>{category}</span>)
    }

    const indices = this.getMatchIndices(this.state.keyword, category);
    const splittedStrings = this.getSplittedStrings(category, indices, this.state.keyword);
    if (splittedStrings.length == 0) {
      return (<span>{category}</span>)
    }
    return (
      splittedStrings.map((str, i) => {
        return (
          str.type === 'match' ?
            <span className="match" key={'match_cat' + productID + i} >{str.segment}</span>
            : <span key={'match_cat' + productID + i}>{str.segment}</span>
        )
      })
    )
  }

  renderDepartment(department, productID) {
    if (!this.state.keyword || this.state.keyword.length < 2) {
      return (<span>{department}</span>)
    }
    const indices = this.getMatchIndices(this.state.keyword, department);
    const splittedStrings = this.getSplittedStrings(department, indices, this.state.keyword);
    if (splittedStrings.length == 0) {
      return (<span>{department}</span>)
    }
    return (
      splittedStrings.map((str, i) => {
        return (
          str.type === 'match' ?
            <span className="match" key={'match_dep' + productID + i} >{str.segment}</span>
            : <span key={'match_dep' + productID + i}>{str.segment}</span>
        )
      })
    )
  }

  getMatchIndices(keyword, description) {
    const regex = new RegExp(keyword, "gi");
    let result = undefined;
    let indices = [];
    while ( (result = regex.exec(description)) ) {
        indices.push(result.index);
    }
    return indices;
  }

  getSplittedStrings(str, indicies, keyword) {
    let splittedStrings = [];
    let substr = '';
    let lastIndex = indicies[0];
    const totalMatches = indicies.length;
    if(totalMatches && lastIndex > 0) {
      substr = str.substring(0, lastIndex);
      splittedStrings.push({
        segment: substr,
        type: 'non-match'
      });
    }
    indicies.forEach((originalIndex, index) => {
      substr = str.substring(lastIndex, lastIndex + keyword.length);
      splittedStrings.push({
        segment: substr,
        type: 'match'
      });
      lastIndex = lastIndex + keyword.length;
      if((index < totalMatches -1) && (indicies[index + 1] > lastIndex)) {
        substr = str.substring(lastIndex, indicies[index + 1]);
        splittedStrings.push({
          segment: substr,
          type: 'non-match'
        });
        lastIndex = indicies[index + 1];
      }
    })
    if(str.length - keyword.length > indicies[indicies.length - 1]) {
      substr = str.substring(indicies[indicies.length - 1] + keyword.length);
        splittedStrings.push({
          segment: substr,
          type: 'non-match'
        });
    }
    return splittedStrings;
  }

}

export default withRouter(connect((state) => {
  return {
    searchResults: state.getIn(['products', 'searchResults'])
  };
})(SearchBox))



// WEBPACK FOOTER //
// ./src/components/commons/header/SearchBox.js